import styles from "./input.module.css";
import Label from "../Label";

const InputBox = ({
  type = "text",
  value,
  onChange,
  placeholder,
  name,
  label,
  inline = false,
  noBottomMargin = false,
  min,
  max,
  onFocus,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: inline ? "row" : "column",
        marginBottom: noBottomMargin ? 0 : 20,
      }}
    >
      <Label name={name} text={label} />
      <input
        id={name}
        className={styles.textBox}
        type={type}
        min={min}
        max={max}
        onPaste={(event) => {
          if (type === "number") {
            event.preventDefault();
          }
        }}
        onKeyDown={(event) => {
          if (type === "number") {
            if (
              event.key === "." ||
              event.key === "e" ||
              event.key === "-" ||
              event.key === "+"
            ) {
              event.preventDefault();
            }
          }
        }}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={onFocus}
      />
    </div>
  );
};

export default InputBox;
